import { ServiceLayout } from "layouts";
import { ServiceMenu, Section, Container } from "components";
import Link from "next/link";
import Head from "next/head";
import * as cx from "classnames/bind";
import s from "styles/Service.module.scss";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

export default function Returns({ policies }) {
  const { t } = useTranslation();
  return (
    <>
      <Head>
        <title key="title">Returns - Service - Cocktail Club</title>
        <meta
          key="ogTitle"
          property="og:title"
          content="Returns - Service - Cocktail Club"
        />
        <meta
          key="ogUrl"
          property="og:url"
          content="https://cocktailclub.com/service/returns"
        />
        <link
          key="canonical"
          rel="canonical"
          href="https://cocktailclub.com/service/returns"
        />
      </Head>
      <ServiceLayout>
        <Section>
          <Container>
            <ServiceMenu title={t("Returns and Refund")} />
            <div className={cx(s.PolicyContent)}>
              <p>
                <b>Cocktail Club / Quenched AS – Returns and Refund</b>
              </p>
              <p>Last updated: 20.08.22</p>
              <br />
              <br />

              <p>
                <strong>CONTENTS</strong>
              </p>
              <ol className={cx(s.PolicyContentList)}>
                <li>OUR POLICY</li>
                <li>REFUNDS</li>
                <li>CONDITIONS FOR RETURN</li>
                <li>HOW CAN YOU CONTACT US ABOUT THIS POLICY?</li>
              </ol>
              <p>&nbsp;</p>
              <p>
                This page (together with the documents referred to on it) tells
                you the returns and refund policy of use on which you may make
                use of this website and any and all other online or digital
                platforms (including without limitation mobile and other
                applications, such as Facebook apps) which we maintain (our
                &ldquo;Site&rdquo;). Please read this policy alongside our main
                terms of use carefully before you start to use our Site and
                before purchasing any products. This policy will apply to any
                order you place with us.
                <br />
                This Site is for the personal use, of persons who are lawfully
                permitted to purchase and consume alcoholic beverages, in
                countries and other territories where the sale, advertising and
                consumption of alcoholic beverages is lawful. By using our Site,
                you indicate that you accept these terms of use and that you
                agree to abide by them. Please exit our Site immediately if you
                do not accept these terms of use.
                <br />
                These terms also refer to
                the&nbsp;Privacy&nbsp;and&nbsp;Cookie&nbsp;Policies, which also
                apply to your use of our Site.
                <br />
                Please exit our Site immediately if you are not of legal age for
                consuming alcoholic beverages in the country or other territory
                in which you are located, or if you are accessing our Site in a
                country or other territory where use of our Site is not
                permitted. Content is to be shared with those over the legal
                drinking age only.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>1. OUR POLICY</strong>
              </p>
              <p>
                If you wish to return an item, you have a 14-day right of
                withdrawal on all goods including sale items. The goods will
                have to be returned to us in the original packaging, unused, and
                in resellable condition. Return shipping will be paid at the
                customers expense and will be required to arrange their own
                shipping.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>2. REFUNDS</strong>
              </p>
              <p>
                When we have received the package in return and approved it, the
                amount for the item(s) will be refunded to your account within
                2-10 working days when paying by card. The refund time can vary
                depending on your bank or card issuer.
              </p>
              <p>
                If you used a gift card when ordering, the relevant amount will
                be refunded to the gift card. Please contact customer service if
                you no longer have your original gift card.
              </p>
              <p>
                Please note, refunds may take up to 30 days to appear in your
                account depending on your bank or card issuer.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>3. CONDITIONS FOR RETURN</strong>
              </p>
              <p>
                Returned items must be in their original, full condition and
                completely unused. All original labels and price tags should be
                attached to the product. Items with stains, strong smells, or
                dirtied in any other way will be considered as used and not
                eligible for return.
              </p>
              <p>&nbsp;</p>
              <p>
                <strong>4. HOW CAN YOU CONTACT US ABOUT THIS POLICY?</strong>
              </p>
              <p>
                If you have any further questions or comments, you may contact
                us through our contact form on our website,{" "}
                <a href="https://cocktailclub.com/service/contact">
                  found here
                </a>
                .
              </p>
              <p>&nbsp;</p>
            </div>
          </Container>
        </Section>
      </ServiceLayout>
    </>
  );
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale)),
  },
});
